import EnFlag from '../Assets/icons/flags/us.png';
import ArFlag from '../Assets/icons/flags/sa.png';
import TrFlag from '../Assets/icons/flags/tr.png';
import RoFlag from '../Assets/icons/flags/ro.png';
import ElFlag from '../Assets/icons/flags/gr.png';
import SpFlag from '../Assets/icons/flags/es.png';
import DuFlag from '../Assets/icons/flags/lu.png';
import DeFlag from '../Assets/icons/flags/de.png';
import FrFlag from '../Assets/icons/flags/fr.png';

export const SystemLanguagesConfig = {
    en: {
        key: 'en',
        icon: EnFlag,
        value: 'en',
    },
    ar: {
        key: 'ar',
        icon: ArFlag,
        value: 'ar',
    },
    tr: {
        key: 'tr',
        icon: TrFlag,
        value: 'tr',
    },
    ro: {
        key: 'ro',
        icon: RoFlag,
        value: 'ro',
    },
    sp: {
        key: 'sp',
        icon: SpFlag,
        value: 'sp',
    },
    el: {
        key: 'el',
        icon: ElFlag,
        value: 'el',
    },
    du: {
        key: 'du',
        icon: DuFlag,
        value: 'du',
    },
    de: {
        key: 'de',
        icon: DeFlag,
        value: 'de',
    },
    fr: {
        key: 'fr',
        icon: FrFlag,
        value: 'fr',
    },
};
